module.exports = __webpack_public_path__ + "assets/ojo_bemakoha_contodo.cdd6bd7c4f958ab586df5495ede3e59a.png";


//////////////////
// WEBPACK FOOTER
// ./img/ojo_bemakoha_contodo.png
// module id = 421
// module chunks = 0